/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * An enumeration of the different types of orders
 */
export enum EnumOrderType {
    /**
     * The type for standard orders
     */
    Standard = 0,
    /**
     * The type for orders which are paid in cash on the spot.
     */
    Cash = 1,
}
